import React from "react"
import SEO from "../components/seo"
import PageBody from "../components/page-body/pageBody"
import BorderTitle from "../components/border-title/borderTitle"
import Button from "../components/button/button"
import { Link } from "gatsby"
import homePhoto from "../images/homephoto.jpg"
import sectionImage1 from "../images/offer.jpg"
import sectionImage2 from "../images/who.jpg"

import "./booking.scss"

const BookingPage = () => (
  <>
    <SEO 
      title="Virtual Mental Health Support Coaching" 
      description="Welcome to the Virtual Mental Health Support Coaching (MHSC) program. Get free, weekly mental health promotion skills training with certified mental health coaches to support your journey toward better mental health and well-being."
      keywords={[`mental health`, `coaching`, `wellness`, `support`, `mhsc`, `vmhsc`, `virtual mental health`, `booking`]} 
    />
    <div className="booking-page">
      <div className="hero-section">
        <div 
          className="hero-background" 
          style={{ backgroundImage: `url(${homePhoto})` }}
          aria-hidden="true"
        />
        <div className="hero-overlay" aria-hidden="true" />
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="title-line-1">THE VIRTUAL</span>
              <span className="title-line-1">MENTAL HEALTH</span>
              <span className="title-line-2">SUPPORT COACHING (MHSC) program</span>
            </h1>
            <p className="hero-subtitle">
            Learn skills and strategies to manage your own stress, depression, anger, grief, and conflict.
            </p>
            <div className="hero-buttons">
              <Link to="/book-appointment">
                <Button className="hero-cta-button">
                  Book a Coaching Session
                </Button>
              </Link>
              <Link to="/replicate-health-smart">
                <Button className="hero-cta-button">
                  Replicate the MHSC Program
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <PageBody className="page">
        <div className="program-overview">
          <BorderTitle className="title">about the program</BorderTitle>
          <p className="overview-description">
          The MHSC Program was originally implemented from 2022-2025 and offered weekly mental health promotion skills training groups for youth and adults, led by community members, respectively, trained to be Mental Health Support Coaches. Participants were given a supportive space to learn practical skills to self-manage stress, depression, anger, grief, and conflict. It was implemented in a historically and predominantly lower-income Black community, though it can be implemented in any community.
          </p>
          <br></br>
          <p className="overview-description">The program is now sustained by certified Community Mental Health Support Coaches and by other organizations replicating the program throughout Florida.</p>
        </div>
      </PageBody>
      
      <div className="program-sections">
          {/* First Section - Image Left, Text Right, White Background */}
          <div className="section-alternating section-white">
            <div className="section-image">
              <img src={sectionImage1} alt="Mental Health Support" />
            </div>
            <div className="section-content">
              <BorderTitle className="section-heading">WHAT WE OFFER</BorderTitle>
              <p className="section-text">
              The MHSC Program continues through our certified Mental Health Support Coaching Program Implementation Coaches, who provide weekly mental health support sessions in supportive group settings. Our Coaches will lead groups of 10-15 participants through three 2-hour sessions, teaching practical skills and behaviors to manage your own stress, depression, anger, grief, and conflict.
              </p>
              <p className="section-text">We also offer the opportunity to start the MHSC Program in your own community. Receive copies of our Coach Training Manual, Participant Resource Guide, and step-by-step guidance in our Implementation Manual.</p>
            </div>
          </div>

          {/* Second Section - Image Right, Text Left, Indigo Background */}
          <div className="section-alternating section-indigo">
            <div className="section-content">
              <BorderTitle className="section-heading">WHO WE SERVE</BorderTitle>
              <p className="section-text">
              We serve all communities, regardless of background. Historically, our program served youth <strong>(12–17 years old)</strong> and adults <strong>(18 years or older)</strong> in historically and predominantly lower-income Black communities. The program was designed to address the urgent need for accessible mental health support in communities where traditional mental health counseling is often unavailable or unaffordable.
              </p>
              <p className="section-text">
                Our commitment to accessibility means you can access support confidently, knowing we're reducing barriers and optimizing our approach to serve those who need it most.
              </p>
              <Link to="/mhsc/recruitment-enrollment">
                <Button className="section-button section-button-indigo">
                  Learn More
                </Button>
              </Link>
            </div>
            <div className="section-image">
              <img src={sectionImage2} alt="Community Support" />
            </div>
          </div>
        </div>
      
      <PageBody className="page">
        <div className="program-impact">
          <BorderTitle className="title">PROGRAM IMPACT</BorderTitle>
          <p className="impact-description">
          The MHSC Program has been found to be statistically significant in effectively reducing commonly experienced stress, depression, grief, feelings of anger, loneliness, and in improving quality of life, social support, and well-being in Black youth and adults.
          </p>
        </div>

        <div className="get-involved-section">
          <h2 className="section-title">Get Started</h2>
          <p className="get-involved-text">
            Ready to begin your journey? Learn more about the program, explore our outcomes, hear from our coaches, and book a coaching session today.
          </p>
          <div className="cta-buttons">
            <Link to="/book-appointment">
              <Button className="enroll-button">
                Book a Coaching Session
              </Button>
            </Link>
            <Link to="/about-mhsc">
              <Button className="learn-more-button">
                Learn More About MHSC
              </Button>
            </Link>
          </div>
        </div>
      </PageBody>
    </div>
  </>
)

export default BookingPage

